import script from "./Oferta.vue?vue&type=script&setup=true&lang=js"
export * from "./Oferta.vue?vue&type=script&setup=true&lang=js"

import "./Oferta.vue?vue&type=style&index=0&id=3d3af22e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d3af22e"]])

export default __exports__